import { initializeApp, getApps } from 'firebase/app';

/**Call static [initializeFirebase] method to initialize.*/
export class FbInit {
	
	private static _isInitialized:boolean = false;
	
	/**initializes Firebase with client settings*/
	public static async initializeFirebase(enableFirestorePersistence:boolean)
			:Promise<void> {
		if (FbInit._isInitialized){
			return;
		}
		
		try {
			if (getApps().length > 0){
				return;
			}
		
			let fbSettings = window['firebase_settings'];
			
			initializeApp({
				apiKey: fbSettings["apiKey"],
				authDomain: fbSettings["authDomain"],
				// databaseURL: fbSettings["databaseURL"],
				projectId: fbSettings["projectId"],
				storageBucket: fbSettings["storageBucket"],
				// messagingSenderId: fbSettings["messagingSenderId"]
			});
			
			// if (enableFirestorePersistence){
			// 	let fs = getFirestore();
			// 	await enableIndexedDbPersistence(fs);
			// }
			
			FbInit._isInitialized = true;
		}
		catch(err){
			console.log(`Firebase Init Error: ${err}`);
		}
	}
}